import type { LinkProps } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { cn } from '~/lib/cn';

export function BreadcrumbsItem({
  to,
  children,
  className,
  ...delegatedProps
}: Partial<LinkProps>) {
  const sharedClasses = cn('break-all', className);

  if (!to) {
    return (
      <span
        aria-current="page"
        className={`text-default ${sharedClasses} `}
        {...delegatedProps}
      >
        {children}
      </span>
    );
  }

  return (
    <Link to={to} className={sharedClasses} {...delegatedProps}>
      {children}
    </Link>
  );
}
BreadcrumbsItem.displayName = 'BreadcrumbsItem';
